<template>
  <h1>Human</h1>
</template>
